//src/components/Hero.jsx
import React from 'react'
import { Slider  } from './utils'
function Hero() {
  return (
<> <Slider />
     
</>
       
  )
}

export default Hero